export default "__VITE_ASSET__Bknjhrme__"